import { Action } from "redux";
import actionCreatorFactory from "typescript-fsa"; // FSA = Flus Standard Actions; has properties type, payload, error (whether payload is error object; optional) and meta (optional).

import * as types from "./actionTypes";

export function widthChanged(width: number) {
  return (dispatch) => {
     dispatch(widthChangedAction(width));
  };
}

// Actual action creators:

const actionCreator = actionCreatorFactory();

export const widthChangedAction = actionCreator<number>(types.WIDTH_CHANGED);
